import { Fragment } from "react"
import { Button, ButtonGroup, Col, Row, Table } from "react-bootstrap"

export const TypeName = {
    0: 'Principal Investigator',
    1: 'Research Fellow',
    2: 'PhD Student',
    3: 'Alumni',
    4: 'Visiting Scholar',
    5: 'Scientific Illustrators'

}

const BlockData = props => {
    const { children, title } = props
    
    return (
        <>
            <h5 className="wlab-font" style={{marginLeft : '30px', marginRight: '30px'}}>{title}</h5>
            <div style={{marginLeft : '30px', marginRight: '30px'}}>{children}</div>
            <br />
        </>
    )
}

export const FullName = ({ data }) => {
    const isLastNameFirst = () => {
        return data?.nationality === 'cn' || data?.nationality === 'vn' || data?.nationality === 'sg'
    }

    return (
        <span className="wlab-font">
            <span className="h5">
                {data?.title || ""}{data?.title?.length > 6 ? <br /> : data?.title ? <span>&nbsp;&nbsp;</span> : <></>}
            </span>
            {isLastNameFirst() ? (
                <span className="h3">
                    {data?.lastname?.toUpperCase()}&nbsp;&nbsp;&nbsp;{data.firstname}
                </span>
            ) : (
                <span className="h3">
                    {data.firstname}&nbsp;&nbsp;&nbsp;{data?.lastname?.toUpperCase()}
                </span>
            )}
            
            <div>{TypeName[data.type]}</div>
            {data.type === 0 ? <div style={{fontStyle: 'normal'}}>
                <br />
                Optica Fellow; IEEE Senior Member; SPIE Member
            </div> : <></>}
        </span>
    )
}

export const FullNamePlainTxt = (data) => {
    const isLastNameFirst = () => {
        return data?.nationality === 'cn' || data?.nationality === 'vn' || data?.nationality === 'sg'
    }

    let s = "";
    if (data?.title) {
        s += `${data?.title} `;
    }

    if (data?.sgname) {
        s += data.sgname;
    }
    else if (data?.lastname && isLastNameFirst()) {
        s += `${data?.lastname.toUpperCase()} ${data?.firstname}`;
    }
    else if (data?.firstname && !isLastNameFirst()) {
        s += `${data?.firstname} ${data?.lastname.toUpperCase()}`;
    }
    return s;
}

export const LinkComp = ({ data }) => {

    if (data?.links && data?.links.length) return (
        <ButtonGroup>
            {data.links.map((link, index) => (
                <Button key={index} hidden={!link?.url}
                    variant="dark"
                    as="a" 
                    href={link?.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    <div className="wlab-font text-light">{link?.platform}</div>
                </Button>
            ))}
        </ButtonGroup>
    )
}



export const ColMemberImg = ({ data }) => {


    const imgSrc = data?.img || `${process.env.PUBLIC_URL}/memberPic/${data?.type}/${data?.index}.jpg`

    return (
        <Col xs='12' md='5' lg='4' xl='3' className="text-center text-light" style={{backgroundColor: 'black', borderRadius: '20px'}}>
            <br />
            <div className="d-none d-md-block">
                <br />
                <img alt='' src={imgSrc} style={{width: '80%', borderRadius: '20px'}}/>
                <br /><br />
                <FullName data={data} />
                <br />
                <LinkComp data={data} />
                <br />
            </div>
            <div className="d-md-none">
                <Row className="align-items-center">
                    <Col xs='4' sm='6'>
                        <img alt='' src={imgSrc} style={{width: '100%', borderRadius: '20px'}}/>
                    </Col>
                    <Col xs='8' sm='6' className="text-start">
                        <FullName data={data} />
                        <br />
                        <LinkComp data={data} />
                    </Col>
                </Row>
            </div>
            <br />
        </Col>
    )
}

export const ColMemberDetails = ({ data }) => {
    return (
        <Col xs='12' md='7' lg='8' xl='9' className="align-content-center">
            <br />
            {data?.description && <BlockData title='Introduction'>
                <div style={{textAlign: 'justify'}}>{data.description}</div>
            </BlockData>}
            <BlockData title='Research Fields'>
                <ul>{data?.fields?.map((f, i) => (
                        <li key={i}>{f}</li>
                ))}</ul>
            </BlockData>
            {data?.education?.length > 0 && <BlockData title='Education Background'>
                <Table borderless className="transparent-table">
                    <tbody>
                        {data?.education?.map((f, i) => (
                            <tr key={i}>
                                <td><b>{f?.years}</b></td>
                                <td >{f?.txt}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </BlockData>}
            
            
            {!!data?.awards?.length && <BlockData title='Awards'>
                {/* <ul>{data?.awards?.map((f, i) => (
                        <li key={i}>{f}</li>
                ))}</ul> */}
                <Table borderless className="transparent-table">
                    <tbody>
                        {data?.awards?.map((f, i) => (
                            <tr key={i}>
                                <td><b>{f?.years}</b></td>
                                <td >{f?.txt}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </BlockData>}


            {!!data?.publications?.length && (
            <BlockData title="Key Publications">
                <ul>{data?.publications?.map((f, i) => {
                    if (f?.journal && f?.txt?.includes(f.journal)) {
                    const parts = f.txt.split(f.journal);
                    return (
                        <li key={i}>
                        {parts.map((part, index) => (
                            <Fragment key={index}>
                            {part}
                            {index < parts.length - 1 && (
                                <b><i>{f.journal}</i></b>
                            )}
                            </Fragment>
                        ))}
                        </li>
                    );
                    }
                    return <li key={i}>{f?.txt}</li>;
                })}
                </ul>
            </BlockData>
            )}

            {!!data?.professionalServices?.length && <BlockData title='Professional Services'>
                <Table borderless className="transparent-table">
                    <tbody>
                        {data?.professionalServices?.map((f, i) => (
                            <tr key={i}>
                                <td><b>{f?.years}</b></td>
                                <td >{f?.txt}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </BlockData>}
            <BlockData title='Contact'>
                {data?.email?.map((f, i) => (
                    <div key={i}>
                        <img alt='' src={`${process.env.PUBLIC_URL}/icons/email.png`} style={{width: '32px'}} />{f}
                    </div>
                ))}
                
            </BlockData>
            <br />
        </Col>
    )
}

/**
 * 
 * 
 * 2022, 2023, 2024 Top 2% of the World’s Best Scientists in Optics
 * 05/2020 Top Three Ideas in Inaugural IBM-NUS Quantum Pitch Contest
2013, 2015, 2016, 2019 FY2012, 2014, 2015, 2018 Best Paper Award (Electronics & Photonics, IHPC)
05/2016 FY2015 Best Industry Project (IHPC)
05/2014 FY2013 Institute Best Paper Award (IHPC)
2001 – 2005 Undergraduate Scholarship By Ministry of Education, Singapore

 */

//arnab: https://scholar.google.com/citations?user=U1EKQtkAAAAJ
//hue: https://scholar.google.com/citations?user=b8Z6c2cAAAAJ
//gx: https://scholar.google.com/citations?user=zvF_4L4AAAAJ